import styled from 'styled-components/macro';
import { rem, TablePagination } from '@nowsta/ux-common-components';

export const Pagination = styled(TablePagination)`
  margin: ${rem(48)} 0 ${rem(30)} 0;
`;
